module.exports = "/fonts/Gineso-Norm-Regular.woff";